import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { GRID_ITEM_LABEL_COLOR, GRID_ITEM_VALUE_COLOR } from '../constants';

interface Props {
  title: string;
  subtitle: string | number | undefined;
}

export const GridItemStat: FC<Props> = ({ title, subtitle }) => (
  <Stack direction='column'>
    <Typography
      sx={{ fontSize: '1.7rem', fontWeight: 400, color: GRID_ITEM_LABEL_COLOR }}
    >
      {title}
    </Typography>
    <Typography
      sx={{ fontSize: '1.8rem', fontWeight: 700, color: GRID_ITEM_VALUE_COLOR }}
    >
      {subtitle}
    </Typography>
  </Stack>
);
